import {
    ORGANIZATION_REQUESTED,
    ORGANIZATION_SPOTS_FAILED,
    ORGANIZATION_SPOTS_FETCH_STARTED,
    ORGANIZATION_SPOTS_SUCCESS,
} from 'contexts/OrganizationsContext/constants';
import {
    SPOT_LIST_REQUESTED,
    SPOT_LIST_SUCCESS,
    SPOT_LIST_FAILED,
    SPOT_MULTIDAY_PRICING_REQUESTED,
    SPOT_MULTIDAY_PRICING_SUCCESS,
    SPOT_MULTIDAY_PRICING_FAILED,
} from '../actions/constants';
import { PricingPayload, SpotInterface, SpotMetadata } from 'types';

export type SpotsState = {
    orgSpotsLoading: boolean;
    orgSpotsErrorMessage: string;
    orgSpots: {
        [index: string]: SpotInterface;
    } | null;
    spot: SpotInterface | null;
    spotMultidayPricing: PricingPayload[] | null;
    spotMultidayPricingLoading: boolean;
    spotMultidayPricingErrorMessage: string;
    spotList: SpotMetadata[] | null;
    spotListLoading: boolean;
    spotListErrorMessage: string;
};

export const initialSpotState: SpotsState = {
    orgSpotsLoading: false,
    orgSpotsErrorMessage: '',
    orgSpots: null,
    spot: null,
    spotMultidayPricing: null,
    spotMultidayPricingLoading: false,
    spotMultidayPricingErrorMessage: '',
    spotList: null,
    spotListErrorMessage: '',
    spotListLoading: false,
};

export default function spotsReducer(state: SpotsState = initialSpotState, action: any): SpotsState {
    const newState: SpotsState = { ...state };
    switch (action.type) {
        case SPOT_LIST_REQUESTED:
            newState.spotListLoading = true;
            return newState;
        case SPOT_LIST_SUCCESS:
            newState.spotListLoading = false;
            newState.spotList = action.payload.spotList;
            return newState;
        case SPOT_LIST_FAILED:
            newState.spotListErrorMessage = action.message;
            newState.spotList = null;
            newState.spotListLoading = false;
            return newState;
        case ORGANIZATION_REQUESTED:
            newState.orgSpots = null;
            newState.orgSpotsErrorMessage = '';
            return newState;
        case ORGANIZATION_SPOTS_FETCH_STARTED:
            newState.orgSpotsLoading = true;
            return newState;
        case ORGANIZATION_SPOTS_SUCCESS:
            newState.orgSpotsLoading = false;
            newState.orgSpots = action.payload.spots;
            return newState;
        case ORGANIZATION_SPOTS_FAILED:
            newState.orgSpotsErrorMessage = action.message;
            newState.orgSpots = null;
            newState.orgSpotsLoading = false;
            return newState;
        case SPOT_MULTIDAY_PRICING_REQUESTED:
            newState.spotMultidayPricing = null;
            newState.spotMultidayPricingLoading = true;
            newState.spotMultidayPricingErrorMessage = '';
            return newState;
        case SPOT_MULTIDAY_PRICING_SUCCESS:
            newState.spotMultidayPricing = action.payload.pricing;
            newState.spotMultidayPricingLoading = false;
            return newState;
        case SPOT_MULTIDAY_PRICING_FAILED:
            newState.spotMultidayPricingErrorMessage = action.message;
            newState.spotMultidayPricingLoading = false;
            return newState;

        default:
            return state || initialSpotState;
    }
}
